export enum ViewRepresentation {
  TEXTURED = 1 ,
  POINT_CLOUD,
  DIFFERENTIAL ,
  SPLITTED_TEXTURED,
  SPLITTED_POINT_CLOUD
}
